module.exports = __webpack_public_path__ + "static/media/019_tatsu.903d9476.gif";